module.exports = __webpack_public_path__ + "static/media/buttons.70a9693c.jpg";